import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import CGU from "./pages/CGU.js";
import CGV from "./pages/CGV.js";
import CONFIDENTIALITE from "./pages/CONFIDENTIALITE.js";
import ForgetPassword from "./pages/ForgetPassword.js";
import Landing_page from "./pages/LandingPage.js";
import PhoneAuth from "./pages/PhoneAuth.js";
import Profile from "./pages/Profile.js";
import StoreRedirect from "./pages/StoreRedirect.js";
import Signin from "./pages/Signin.js";
import Signup_brand from "./pages/Signup_brand.js";
import Signup_influencer from "./pages/Signup_influencer.js";
import TopOutfits from "./pages/TopOutfits.js";
import AuthProvider from "./services/AuthProvider.js";
import PrivateRoute from "./components/PrivateRoute.js";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route index element={<Landing_page />} />
            <Route path="*" element={<Landing_page />} />
            <Route path="/phone" element={<PhoneAuth />} />
            <Route path="/landing" element={<Landing_page />} />
            <Route path="/signup_influencer" element={<Signup_influencer />} />
            <Route path="/signup_brand" element={<Signup_brand />} />
            <Route path="/signin" element={<Signin />} />
            <Route path="/store/:influencerName" element={<StoreRedirect />} />
            <Route
              path="/top_outfits"
              element={
                <PrivateRoute>
                  <TopOutfits />
                </PrivateRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              }
            />
            <Route path="/forget_password" element={<ForgetPassword />} />
            <Route path="/CGU" element={<CGU />} />
            <Route path="/CGV" element={<CGV />} />
            <Route path="/CONFIDENTIALITE" element={<CONFIDENTIALITE />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
